import { CUSTOM_ELEMENTS_SCHEMA, NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecalculateSalesPricesComponent } from './recalculate-sales-prices.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from '../directives/directives.module';
import { PipesModule } from '../pipes/pipes.module';

@NgModule({
  declarations: [ RecalculateSalesPricesComponent ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    DirectivesModule,
    FormsModule,
    ReactiveFormsModule,
    PipesModule
  ],
  providers: [ ],
  exports: [ RecalculateSalesPricesComponent ]
})
export class RecalculateSalesPricesModule {
  customElementComponent: Type<any> = RecalculateSalesPricesComponent;
 }
